import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/section.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

function ML() {
    return (
        <div className="section-container">
            <Header />
            <main className="section-content">
                <p className="section-intro-paragraph">Learn about all kinds of NLP models</p>
                <div className="subsection-links">
                    <Link to="/ml/mlalgo">Foundational ML Algorithms</Link>
                    <Link to="/ml/classic">Classic NLP</Link>
                    <Link to="/ml/cnn">CNNs & Variants</Link>
                    <Link to="/ml/rnn">RNNs & Variants</Link>
                    <Link to="/ml/seq2seq">Seq2Seq & Transformers</Link>
                    <Link to="/ml/adv">Other Architectures</Link>
                    <Link to="/ml/transfer">Transfer Learning</Link>
                </div>
            </main>
            <Footer />
        </div>
    );
}

export default ML;